/** Authenticator dashboard + artwork/artist review workflows. */
export const canAccessAuthenticatorDashboard = (user) =>
  user?.role === 'authenticator' || user?.is_admin === true || user?.is_superadmin === true;

/** Purchase-information tab (authenticators with flag, or any admin). */
export const canUsePurchaseCheck = (user) =>
  user?.is_purchase_check === true || user?.is_admin === true || user?.is_superadmin === true;

/** Single-vote threshold override on artwork approval. */
export const isSuperAdmin = (user) => user?.is_superadmin === true;
